import { takeLatest } from 'redux-saga/effects';
import generateSaga from '../utils/generateSaga';
import HTTPMethod from '../ts/enums/HTTPMethod.enum';
import {
  CDF_UNIT_FUNDING_AMOUNT_PREFIX,
  createCdfUnitFundingAmount,
  fetchCdfUnitFundingAmount,
} from 'reducers/cdfUnitFundingAmountReducer';

export default function* watch() {
  yield takeLatest(
    fetchCdfUnitFundingAmount,
    generateSaga(fetchCdfUnitFundingAmount, {
      method: HTTPMethod.POST,
      prefix: CDF_UNIT_FUNDING_AMOUNT_PREFIX,
    }),
  );
  yield takeLatest(
    createCdfUnitFundingAmount,
    generateSaga(createCdfUnitFundingAmount, {
      method: HTTPMethod.PUT,
      loading: 'Adding new Funding Amount...',
      success: 'Funding Amount added successfully!',
      prefix: CDF_UNIT_FUNDING_AMOUNT_PREFIX,
    }),
  );
}
